export var triggerScreenReader = function triggerScreenReader(message) {
  var clearAlertTimeout = 1000;
  var myAlert = document.createElement('p');
  myAlert.setAttribute('role', 'alert');
  myAlert.setAttribute('aria-live', 'assertive');
  myAlert.setAttribute('style', 'position:absolute;left:-9999px;top:0;height:0;width:0;');
  var myAlertText = document.createTextNode(message);
  myAlert.appendChild(myAlertText);
  document.body.appendChild(myAlert);
  window.setTimeout(function () {
    document.body.removeChild(myAlert);
  }, clearAlertTimeout);
};